(()=>{
  'use strict';
  const narrow=matchMedia('(max-width:760px), (max-width:1023px) and (pointer:coarse)');
  const mount=()=>{
    const header=document.querySelector('#UraHeader .ura-header__control-rail');
    const language=header?.querySelector('.ura-header__language')||document.querySelector('[data-ura-mobile-language]>.ura-header__language');
    const host=document.querySelector('[data-ura-mobile-language]');
    const utility=header?.querySelector('.ura-home-utility-island');
    if(language&&host&&header){
      if(narrow.matches)host.append(language);
      else header.insertBefore(language,utility||null);
    }
    document.querySelectorAll('[data-ura-mobile-disclosure]').forEach(disclosure=>{
      if(disclosure.dataset.uraMobileMode===String(narrow.matches))return;
      disclosure.dataset.uraMobileMode=String(narrow.matches);
      disclosure.open=!narrow.matches;
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  narrow.addEventListener('change',mount);
  document.addEventListener('shopify:section:load',mount);
  const footer=document.querySelector('[data-ura-u-footer]');
  if(footer&&'IntersectionObserver' in window&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
    footer.classList.add('is-prepared');
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){footer.classList.add('is-visible');observer.disconnect()}
    },{threshold:.18});
    observer.observe(footer);
  }
})();

(()=>{
  'use strict';
  const mobile=matchMedia('(max-width:760px), (max-width:1023px) and (pointer:coarse)');
  let destroyPurchase=()=>{};
  const mountPurchase=()=>{
    destroyPurchase();
    const bar=document.querySelector('[data-ura-mobile-purchase]');
    const root=document.querySelector('[data-ura4-product]');
    const native=root?.querySelector('[data-ura4-add]');
    if(!bar||!root||!native)return;
    const button=bar.querySelector('[data-ura-mobile-buy]');
    const abort=new AbortController(),signal=abort.signal;
    let frame=0,submitting=false,contentDirty=true;
    const priceNode=root.querySelector('[data-ura4-price]');
    const summary=root.querySelector('[data-ura4-selection]');
    const heading=root.querySelector('h1');
    const labelNode=root.querySelector('[data-ura4-add-label]');
    const barPrice=bar.querySelector('[data-ura-mobile-price]');
    const barChoice=bar.querySelector('[data-ura-mobile-choice]');
    const barLabel=bar.querySelector('[data-ura-mobile-buy-label]');
    const header=document.querySelector('[data-ura-header]');
    const footer=document.querySelector('footer#UraSiteFooter,#UraSiteFooter');
    const text=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value;};
    const visible=node=>Boolean(node?.getClientRects().length)&&getComputedStyle(node).visibility!=='hidden';
    const update=()=>{
      frame=0;
      if(document.hidden)return;
      if(!mobile.matches){
        if(!bar.hidden)bar.hidden=true;
        if(document.body.hasAttribute('data-ura-mobile-bar-visible'))document.body.removeAttribute('data-ura-mobile-bar-visible');
        return;
      }
      const top=header?.getBoundingClientRect().bottom||64;
      const hasPassed=visible(native)&&native.getBoundingClientRect().bottom<=Math.max(0,top);
      const overlay=[...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],#ura-mega-menu:not([hidden])')].some(visible);
      const keyboard=document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,[contenteditable="true"]');
      const atFooter=footer&&footer.getBoundingClientRect().top<innerHeight-80;
      const show=hasPassed&&!overlay&&!keyboard&&!atFooter;
      const preview=document.getElementById('PBarNextFrame')?.parentElement;
      const previewHeight=visible(preview)?Math.min(88,preview.getBoundingClientRect().height):0;
      if(contentDirty){
        contentDirty=false;
        const price=priceNode?.textContent.trim()||'';
        const title=heading?.textContent.trim()||'';
        const label=labelNode?.textContent.trim()||'';
        text(barPrice,price);
        text(barChoice,summary&&!summary.hidden?summary.textContent.trim():title);
        text(barLabel,label);
        const disabled=native.disabled||submitting;
        if(button.disabled!==disabled)button.disabled=disabled;
        const accessible=[label,title,price].filter(Boolean).join(', ');
        if(button.getAttribute('aria-label')!==accessible)button.setAttribute('aria-label',accessible);
      }
      if(bar.hidden===show)bar.hidden=!show;
      if(document.body.hasAttribute('data-ura-mobile-bar-visible')!==show)document.body.toggleAttribute('data-ura-mobile-bar-visible',show);
      const dock=previewHeight+'px';
      if(bar.style.getPropertyValue('--ura-preview-dock')!==dock)bar.style.setProperty('--ura-preview-dock',dock);
    };
    const queue=()=>{if(!frame&&!document.hidden)frame=requestAnimationFrame(update);};
    const refreshContent=()=>{contentDirty=true;queue();};
    button.addEventListener('click',()=>{
      if(native.disabled||submitting)return;
      const needsSize=root.querySelector('[data-ura4-size-input]')&&!root.querySelector('[data-ura4-size-input]:checked');
      if(needsSize){native.click();queue();return;}
      submitting=true;button.disabled=true;
      native.click();
      setTimeout(()=>{submitting=false;refreshContent();},750);
    },{signal});
    const observer=new MutationObserver(refreshContent);
    observer.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','hidden','aria-busy','checked','value']});
    const overlays=new MutationObserver(queue);
    overlays.observe(document.body,{attributes:true,attributeFilter:['class']});
    document.querySelectorAll('#UraCartDrawer,#ura-mega-menu,dialog').forEach(el=>overlays.observe(el,{attributes:true,attributeFilter:['class','hidden','open','aria-hidden']}));
    ['scroll','resize','pageshow'].forEach(type=>addEventListener(type,queue,{passive:true,signal}));
    ['focusin','focusout'].forEach(type=>document.addEventListener(type,queue,{signal}));
    document.addEventListener('change',refreshContent,{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else refreshContent();},{signal});
    window.visualViewport?.addEventListener('resize',queue,{passive:true,signal});
    mobile.addEventListener('change',queue,{signal});
    update();
    destroyPurchase=()=>{abort.abort();observer.disconnect();overlays.disconnect();cancelAnimationFrame(frame);bar.hidden=true;document.body.removeAttribute('data-ura-mobile-bar-visible');};
  };
  const start=()=>mountPurchase();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
  document.addEventListener('shopify:section:unload',()=>destroyPurchase());

  const key='ura-mobile-browse-1003';
  const read=()=>{try{const value=JSON.parse(sessionStorage.getItem(key)||'null');return value&&Date.now()-value.time<1800000?value:null;}catch(_){return null;}};
  const write=value=>{try{sessionStorage.setItem(key,JSON.stringify(value));}catch(_){}};
  const sourcePath=()=>location.pathname+location.search;
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');
    if(!mobile.matches||!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin)return;
    if(url.pathname.includes('/products/')&&link.closest('[data-ura2-catalog],.ura-mobile-arrivals,.ura-shopping-arrivals')){
      write({path:sourcePath(),y:scrollY,time:Date.now(),returning:false});
    }
    if(link.matches('[data-ura-shop-return]')){
      const saved=read();if(!saved)return;
      const destination=new URL(saved.path,location.origin);
      if(destination.origin!==location.origin||!(/^\/(?:[a-z]{2}\/)?collections\//.test(destination.pathname)||/^\/(?:[a-z]{2}\/)?$/.test(destination.pathname)))return;
      saved.returning=true;write(saved);link.href=destination.href;
      try{const referrer=new URL(document.referrer);if(referrer.origin===location.origin&&referrer.pathname+referrer.search===saved.path){event.preventDefault();history.back();}}catch(_){}
    }
  });
  const restore=event=>{
    const saved=read();if(!mobile.matches||!saved||saved.path!==sourcePath())return;
    const back=performance.getEntriesByType('navigation')[0]?.type==='back_forward';
    if(!saved.returning&&!back&&!event?.persisted)return;
    saved.returning=false;write(saved);
    if(event?.persisted)return;
    let cancelled=false;
    const stop=()=>{cancelled=true;};
    ['pointerdown','touchstart','wheel','keydown'].forEach(type=>addEventListener(type,stop,{once:true,passive:true}));
    const place=()=>{if(!cancelled&&sourcePath()===saved.path)scrollTo({top:saved.y,behavior:'instant'});};
    requestAnimationFrame(()=>requestAnimationFrame(place));
    if(document.readyState!=='complete')addEventListener('load',place,{once:true});
    setTimeout(()=>{['pointerdown','touchstart','wheel','keydown'].forEach(type=>removeEventListener(type,stop));},1800);
  };
  addEventListener('pageshow',restore);
})();

(()=>{
  const mount=()=>{
    const mark=document.querySelector('[data-ura-shop-signature]');
    if(!mark||mark.dataset.ready)return;
    mark.dataset.ready='true';
    if(!matchMedia('(max-width:760px), (max-width:1023px) and (pointer:coarse)').matches||matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    try{
      if(sessionStorage.getItem('ura-shop-signature-seen'))return;
      sessionStorage.setItem('ura-shop-signature-seen','1');
      mark.classList.add('is-animating');
      mark.addEventListener('animationend',event=>{if(event.animationName==='ura-shop-line')mark.classList.remove('is-animating')},{once:false});
    }catch(_){}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();
